module.exports = __webpack_public_path__ + "img/shuju.fb718384.png";